import * as React from 'react';
import type { EntityDetail, ConfigEntityDetail } from '@web-config-app/core';
import { isUsingConfigAppBackend } from '@web-config-app/common';
import { linkableRendererRegistry } from '../cell-renderers/renderer-registry';
import {
  EntityListTable,
  type RowContext,
} from '../entity-list-table/entity-list-table.component';
import type { EntityListTableProps } from '../../../types/components.types';

export const LinkableEntityListTable = ({
  getItemLinkUrl,
  getItemName,
  entityData,
  isLoading,
  domainEntity,
  selectionMode = 'none',
  selectionProps,
  bulkActions,
}: EntityListTableProps<ConfigEntityDetail | EntityDetail>) => {
  const getRowContext = React.useCallback(
    (item: ConfigEntityDetail | EntityDetail): RowContext => {
      const linkTo = getItemLinkUrl(item.id);

      const shouldUseDomainEntityId = isUsingConfigAppBackend({
        entityLevelOverride: domainEntity.isUsingConfigAppBackend,
      });
      const itemId = shouldUseDomainEntityId
        ? item.attributes.entityMetadata.domainEntityId
        : item.id;

      return {
        linkTo,
        itemId,
        selected: selectionProps?.getItemSelectionState?.(item.id) ?? false,
        onSelect: () => selectionProps?.onEntitySelected?.(item),
      };
    },
    [getItemLinkUrl, domainEntity.isUsingConfigAppBackend, selectionProps],
  );

  return (
    <EntityListTable
      entityData={entityData}
      isLoading={isLoading}
      domainEntity={domainEntity}
      getItemName={getItemName}
      selectionMode={selectionMode}
      selectionProps={selectionProps}
      bulkActions={bulkActions}
      getRowContext={getRowContext}
      registry={linkableRendererRegistry}
    />
  );
};
